import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  PasswordInput,
  ScrollArea,
  Select,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { CREATE_WAREHOUSE_MANAGER } from "apollo/mutuations";
import { GET_MY_WARE_HOUSES, GET_WARE_HOUSE_MANAGERS } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import { useState } from "react";

const WarehouseManagerAddModal = ({ setOpened, size, activePage }) => {
  const [warehouses, setWarehouses] = useState([]);

  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      password: "",
      address: "",
      city: "",
      password_confirmation: "",
      warehouse_id: "1",
    },

    validate: {
      password: (value) => {
        if (!value) return "Password is required";
        if (value.length < 8) return "Password must be at least 8 characters";
        if (!/[A-Z]/.test(value))
          return "Password must contain at least one uppercase letter";
        if (!/[0-9]/.test(value))
          return "Password must contain at least one number";
        if (!/[^A-Za-z0-9]/.test(value))
          return "Password must contain at least one special character";
        return null;
      },
      password_confirmation: (value, values) => {
        if (value !== values.password) {
          return "Passwords do not match!";
        }
        return null;
      },
    },
  });
  const { loading: supplierLoading } = useQuery(GET_MY_WARE_HOUSES, {
    variables: {
      first: parseInt(1000),
      page: 1,
    },

    onCompleted(data) {
      const arr = data.myWarehouses.data
        .filter((item) => item.status === "ACTIVE")
        .map((item) => ({
          label: item.name,
          value: item.id,
        }));

      setWarehouses(arr);
    },
  });
  // mutation
  const [addWarhouseManager, { loading: warehouseManagerLoading }] =
    useMutation(CREATE_WAREHOUSE_MANAGER, {
      update(cache, { data: { createWarehouseManager } }) {
        cache.updateQuery(
          {
            query: GET_WARE_HOUSE_MANAGERS,
            variables: {
              first: parseInt(size),
              page: activePage,
              search: "",
              ordered_by: [
                {
                  column: "CREATED_AT",
                  order: "DESC",
                },
              ],
            },
          },
          (data) => {
            if (data) {
              return {
                myWarehouseManagers: {
                  ...data?.myWarehouseManagers,
                  data: [
                    createWarehouseManager,
                    ...data?.myWarehouseManagers?.data,
                  ],
                },
              };
            }
          },
        );
      },
    });

  const { height } = useViewportSize();
  const submit = () => {
    if (form.validate().hasErrors) {
      return;
    }
    addWarhouseManager({
      variables: {
        name: form.getInputProps("name").value,
        phone: form.getInputProps("phone").value,
        email: form.getInputProps("email").value,
        //  city: form.getInputProps("city").value,
        //  address: form.getInputProps("address").value,
        password: form.getInputProps("password").value,
        password_confirmation: form.getInputProps("password_confirmation")
          .value,
        warehouse_id: form.getInputProps("warehouse_id").value,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Warhouse Manager Created Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message ||
            "Warhouse Manager Not Created Successfully!",
        });
      },
    });
  };
  const handleWarehouseChange = (val) => {
    form.setFieldValue("warehouse_id", val);
  };
  return (
    <>
      <LoadingOverlay
        visible={warehouseManagerLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Name"
                  placeholder="Name"
                  {...form.getInputProps("name")}
                />
                <Select
                  required
                  searchable
                  data={warehouses}
                  value={form.getInputProps("warehouse_id").value.toString()}
                  onChange={handleWarehouseChange}
                  label="Warhouse"
                  placeholder="Pick a warhouse this belongs to"
                />
                <PasswordInput
                  placeholder="Password"
                  label="Password"
                  {...form.getInputProps("password")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Contact Email"
                  placeholder="Email"
                  {...form.getInputProps("email")}
                />
                <TextInput
                  required
                  label="Contact Phone"
                  placeholder="Phone"
                  {...form.getInputProps("phone")}
                />

                <PasswordInput
                  placeholder="Confirm Password"
                  label="Confirm Password"
                  error={form.errors.password_confirmation}
                  {...form.getInputProps("password_confirmation")}
                />
              </Grid.Col>
            </Grid>

            <Grid>
              <Grid.Col span={4}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "15px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};

export default WarehouseManagerAddModal;
